import styled from 'styled-components';
import { COLORS } from '../../../styles/variables';
import { AlphaTheme } from '../../../../design-system/ThemeProvider/alphaTheme';

interface WrapperProps {
  isActive?: boolean;
  isCaMarket?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  height: 100%;
  min-width: 280px;
  max-width: 280px;

  @media (min-width: 768px) {
    min-width: 384px;
    max-width: 384px;
  }

  @media (min-width: 1024px) {
    min-width: 560px;
    max-width: 560px;
  }

  .product-card {
    min-width: 280px;
    max-width: 280px;
    height: 100%;

    @media (min-width: 768px) {
      min-width: 384px;
      max-width: 384px;
    }

    @media (min-width: 1024px) {
      min-width: 560px;
      max-width: 560px;
    }

    img {
      border-radius: 0 0 20px 20px;
    }

    div:nth-child(2) {
      // Note: Configuration for the product card content to take full height of the slot1 and then auto the height of the title
      div:first-child:not(:is(.product-card__content__header, .product-card__content__header *)) {
        height: 100%;
        div:first-child:not(:is(.product-card__content__header, .product-card__content__header *)) {
          height: auto;
          gap: 12px;
        }
      }
      div:nth-child(2):not(
          :is(
            .product-card__content,
            .product-card__content *,
            .product-card__content__description,
            .product-card__content__description *
          )
        ) {
        display: none;
      }
      div:nth-child(1):not(:is(.product-card__content, .product-card__content *, )) {
        padding: 0;
        gap: 0;
      }

      .product-card__content {
        display: flex;
        flex-direction: column;
        gap: var(--Sys-Space-Fixed-150, 12px);
        height: 100%;

        &.ca-market {
          gap: 32px;
        }

        .product-card__tag {
          position: absolute;
          top: 0;
          left: 0;
          margin: 16px 0 0 24px;
          min-height: auto;
          background-color: transparent;
          padding: 0;
        }

        .product-card__content__header {
          display: flex;
          flex-direction: column;

          .offer-offer-plus {
            display: none;
          }

          .ca-market {
            order: -1;
            margin: 8px 0 16px 0;
          }

          .offer__expiry__details {
            justify-content: flex-start;
            gap: 32px;
          }
        }

        p {
          font-size: var(--Sys-FontSizes-Relative-85, 14px);
        }

        .product-card__content__trimname {
          font-size: var(--Sys-FontSizes-Relative-100, 16px);
          margin: 8px 0 16px 0;
        }

        .product-card__content__info {
          display: flex;
          align-items: center;
          align-content: flex-start;
          gap: var(--Sys-Space-Fixed-100, 8px) var(--Sys-Space-Fixed-400, 32px);
          align-self: stretch;
          flex-wrap: wrap;
          margin-bottom: 16px;
        }
        div:last-child {
          margin-top: auto;
        }

        .product-card__content__description-ca-market {
          font-size: var(--Sys-FontSizes-Relative-75, 12px);
        }

        .product-card__content__description {
          margin-top: auto;
          margin-bottom: 0;
          overflow-y: hidden;

          p {
            font-size: var(--Sys-FontSizes-Relative-75, 12px);
          }
        }
      }
    }
  }
`;

export const VehicleNameWrapper = styled.div`
  padding-bottom: 12px;
`;

export const Title = styled.h3`
  margin: 0;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral100 ?? COLORS.grey80};
  font-family: 'Audi Type';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.002px;
`;

export const TrimLineWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 4px;
`;

export const DescriptionWrapper = styled.div`
  margin-bottom: 8px;
  max-height: 126px;
  overflow-y: auto;
`;

export const ViewOfferCTA = styled.button`
  padding: 0;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  color: ${({ theme }: { theme: Partial<AlphaTheme> }) =>
    theme.foregroundNeutral200 ?? COLORS.grey60};
  font-family: 'Audi Type';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.002px;
  cursor: pointer;
`;

export const InfoContainer = styled.div`
  width: 100%;
`;

export const CTAGroup = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .featured-offer-button {
    flex: 1;
    width: 100%;
  }

  @media (min-width: 769px) {
    flex-direction: column;

    .featured-offer-button {
      width: 100%;
    }

    @media (min-width: 1440px) {
      flex-direction: row;
    }
  }
`;

export const ProductCardBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  maring-top: auto;

  p {
    font-size: 12px;
  }
  @media screen and (max-width: 1024px) {
    padding-top: 12px;
  }
`;
